<div style="width:800px;height:400px;" *ngIf="committees.length > 0">
  <span> <button class="btn btn border" (click)="save()">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br><br>
  <form [formGroup]="form" style="width:95%;">
    <mat-radio-group aria-label="Typ" formControlName="type" (change)="clearForm($event)" required>
      <mat-radio-button value="1">Utskott och Institution</mat-radio-button>
      <mat-radio-button value="2">Utskott och Institutionstyp</mat-radio-button>
    </mat-radio-group>
    <br><br>
    <div class="row">
      <div class="col-md-6">
        <label>
          Utskott
        </label>
        <p-select [options]="committees" [filter]="true" filterBy="label" [showClear]="true" formControlName="committeeId" placeholder="Välj Utskott" [style]="{'width':'100%', 'height':'40px'}" (onChange)="setCommittee($event)"></p-select>
      </div>
      <div class="col-md-5" *ngIf="form.get('type').value==='1'">
        <label>
          Institution
        </label>
        <p-select [options]="institutions" [filter]="true" filterBy="label" [showClear]="true" formControlName="institutionId" placeholder="Välj institution" [style]="{'width':'100%', 'height':'40px'}" (onChange)="setInstitution($event)"></p-select>
      </div>
      <div class="col-md-5" *ngIf="form.get('type').value==='2'">
        <label>
          Institutionstyp
        </label>
        <p-select [options]="institutiontypes" [filter]="true" filterBy="label" [showClear]="true" formControlName="institutionTypeId" placeholder="Välj institutionstyp" [style]="{'width':'100%', 'height':'40px'}" (onChange)="setInstitutionType($event)"></p-select>
      </div>
    </div>
  </form>
</div>